export default "__VITE_ASSET__Be783cOh__"